import React, { useState, useEffect } from 'react';
import Modal from '../../atoms/modal/view';
import ComprobanteForm from '../../molecules/ComprobanteForm/view.jsx';
import { createComprobante, getComprobante } from '../../../usecases/accounting-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { dateFormat } from '../../../utils/helper';

const AnularComprobanteModal = () => {
    const [anularData, setAnularData] = useState(null);
    const id = "anularComprobanteModal";

    useEffect(() => {
        const handleAnularData = async (event) => {
            let original = event.detail.data;
            if (!original) return;

            // Si el objeto no tiene líneas, intentamos obtenerlas del backend
            if ((!original.lineas || original.lineas.length === 0) && (!original.lines || original.lines.length === 0)) {
                try {
                    const fullData = await getComprobante(original.id);
                    if (fullData) {
                        original = fullData;
                    }
                } catch (error) {
                    console.error("Error fetching full comprobante for anular:", error);
                }
            }

            const currentDate = new Date();

            const linesSource = original.lineas || original.lines || [];
            const mappedLines = linesSource.map((line, idx) => {
                const uAcc = line.users_accounts || line.user_account;
                const accountDescription = uAcc?.description || line.descripcion || undefined;

                let accountCode = "N/A";
                if (uAcc && uAcc.account) {
                    const baseCode = uAcc.account.account || "";
                    const code = uAcc.code !== undefined ? uAcc.code : "";
                    accountCode = code > 9 ? `${baseCode}${code}` : `${baseCode}0${code}`;
                } else if (uAcc?.code) {
                    accountCode = uAcc.code;
                }

                return {
                    numero_linea: line.numero_linea || (idx + 1),
                    cuenta_contable_id: line.cuenta_contable_id || uAcc?.id,
                    tercero_id: line.tercero_id || line.third_id,
                    tercero_object: line.tercero_object || line.tercero || line.third,
                    centro_costo_id: line.centro_costo_id || 1,
                    // Intercambiar débito y crédito
                    valor_debito: Number(line.valor_credito || 0),
                    valor_credito: Number(line.valor_debito || 0),
                    descripcion: line.descripcion || '',
                    aditional_info: {
                        ...uAcc,
                        account: accountCode,
                        description: accountDescription,
                        need_third: uAcc?.need_third || line.need_third || false
                    }
                };
            });

            const rawDocType = original.document_type || original.tipo || original.type || '';
            let finalDocType = rawDocType;
            if (rawDocType.includes('(') && rawDocType.includes(')')) {
                const match = rawDocType.match(/\(([^)]+)\)/);
                if (match) finalDocType = match[1];
            }
            if (finalDocType === 'N/A') finalDocType = '';

            const originalDoc = original.document || '';
            const newDocument = originalDoc ? `Anulación - ${originalDoc}` : 'Anulación';

            setAnularData({
                descripcion: `Anulación de: ${original.descripcion || original.concept || original.id || ''}`,
                document_type: finalDocType,
                document: newDocument,
                document_number: original.document_number || original.number || '',
                date: dateFormat(currentDate),
                lineas: mappedLines
            });

            // Si el comprobante original tiene un ID, cerramos su modal de detalle
            if (original.id) {
                dispatchCustomEvent(`close-comprobante${original.id}-modal`, []);
            }

            // Abrir el modal usando el sistema de eventos de átomos/modal
            dispatchCustomEvent(`modal${id}`, { eventKey: id });
        };

        window.addEventListener('anular-comprobante-data', handleAnularData);
        return () => window.removeEventListener('anular-comprobante-data', handleAnularData);
    }, []);

    const handleSave = async (formData) => {
        try {
            await createComprobante(formData);
            dispatchCustomEvent(`close-${id}-modal`, []);
            dispatchCustomEvent("popup", { message: "Comprobante anulado correctamente", type: "success" });
            dispatchCustomEvent("reload-comprobantes", {});
        } catch (error) {
            console.error("Error voiding comprobante:", error);
            dispatchCustomEvent("popup", { message: "Error al anular el comprobante. Verifique que los datos sean válidos.", type: "error" });
            dispatchCustomEvent('loading-btn-comprobante-save', {});
        }
    };

    return (
        <Modal
            id={id}
            title="Anular Comprobante"
            width="80vw"
        >
            {anularData && (
                <ComprobanteForm
                    initialData={anularData}
                    onSave={handleSave}
                    submitTitle="Anular Comprobante"
                />
            )}
        </Modal>
    );
};

export default AnularComprobanteModal;
